export default {
    appVersion: "1.7.0-ci.20261103.3",
    apiVersion: "1.6",
  }